module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Profile_Icon.9c7ddfcc.png";